
import Util from "@/ts/Util";
import feather from "feather-icons";
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {},
  props: {
    userName: String,
    userPhoto: String,
    clickLogout: Function,
    clickChange: Function,
  },
})
export default class SlideNav extends Vue {
  static navigationItems: any = [];

  static organizationData: any = {};

  static instance: any;
  options = SlideNav.navigationItems;

  mounted() {
    $(".sidenav").sidenav();
    $(".collapsible").collapsible();
    SlideNav.instance = this;
  }

  updated() {
    feather.replace();
  }

  static refresh() {
    SlideNav.instance.organizationData = JSON.parse(
      sessionStorage.getItem("ORGANIZATION_DATA") || "{}"
    ).CONFIGURATIONS.APP_LAYOUT_CONFIG.slideNav;

    SlideNav.navigationItems = SlideNav.instance.mapOptions(
      SlideNav.instance.organizationData
    );

    const instance = SlideNav.instance;
    if (instance) {
      instance.options = SlideNav.navigationItems;
      setTimeout(() => {
        $(".sidenav").sidenav();
        $(".collapsible").collapsible();
      }, 500);
    }
  }

  mapOptions(items: any[]): any {
    let mappedItems: any = [];

    SlideNav.organizationData = JSON.parse(
      sessionStorage.getItem("ORGANIZATION_DATA") || "{}"
    ).CONFIGURATIONS.APP_LAYOUT_CONFIG.slideNav;

    mappedItems = items.map((i: any) => {
      const defaultItems: any = SlideNav.defaultItems();
      const item = defaultItems.find((o: any) => i.id == o.id);
      if (!item) mappedItems = [];

      return {
        ...item,
        name: i.name.split("_")[0],
        icon: i.icon.map(() => ["fal", i.icon[0]])[0],
        child: this.mapOptions(i.child || []) || [],
      };
    });

    return mappedItems;
  }

  static defaultItems(): any {
    return [
      {
        id: "0",
        name: "Perfil",
        icon: ["fal", "user"],
        router: "Perfil",
        click: [],
        child: [],
      },
      {
        id: "1",
        name: "Dependentes",
        icon: ["fal", "users"],
        router: "Dependents",
        click: [],
        child: [],
      },
      {
        id: "2",
        name: "Carteira",
        icon: ["fal", "wallet"],
        router: "Carteira",
        click: [],
        child: [],
      },
      {
        id: "3",
        name: "Documentos",
        icon: ["fal", "file"],
        router: "Documents",
        click: [],
        child: [],
      },
      {
        id: "4",
        name: "Ouvidoria",
        icon: ["fal", "volume"],
        router: "SupportRequest",
        click: [],
        child: [],
      },
      {
        id: "5",
        name: "Boletos",
        icon: ["fal", "file-alt"],
        router: "MeusBoletos",
        click: [],
        child: [],
      },
      {
        id: "6",
        name: "Pesquisa de Satisfação",
        icon: ["fal", "clipboard"],
        router: "Surveys",
        click: [],
        child: [],
      },
      {
        id: "7",
        name: "Mais Informações",
        icon: ["fal", "plus-square"],
        router: "",
        click: [],
        child: [],
      },
      {
        id: "8",
        name: "Sair",
        icon: ["fal", "sign-out-alt"],
        router: "",
        click: [SlideNav.instance.$props.clickLogout],
        child: [],
      },
      {
        id: "9",
        name: "Pessoas no Clube",
        icon: ["far", "umbrella"],
        router: "PessoasNoClube",
        click: [],
      },
      {
        id: "10",
        name: "Trocar de Clube",
        icon: ["far", "sync"],
        router: "",
        click: [SlideNav.instance.$props.clickChange],
      },
      {
        id: "11",
        name: "Sobre",
        icon: ["far", "info-circle"],
        router: "About",
        click: [],
      },
      {
        id: "12",
        name: "Aluguel de Espaços",
        icon: ["far", "key"],
        router: "SpaceRent",
        click: [],
      },
      {
        id: "13",
        name: "Perfil",
        icon: ["fal", "user"],
        router: "PerfilDelivery",
        click: [],
        child: [],
      },
    ];
  }

  close() {
    $(".sidenav").sidenav("close");
  }

  chooseOrg() {
    try {
      sessionStorage.setItem("USER_DATA", "");
      sessionStorage.setItem("TOTP", "");
      sessionStorage.setItem("USER_DATE", "");
      sessionStorage.setItem("EVENTS", "");
      sessionStorage.setItem("ENTERED_ORDERS_FROM", "");
      sessionStorage.setItem("ORG_FIELDS", "");
      sessionStorage.setItem("stores", "");
      sessionStorage.setItem("USER_TICKETS", "");
      sessionStorage.setItem("STRUCTURES", "");
      sessionStorage.setItem("DADOS_USUARIOS", "");
      sessionStorage.setItem("LAST_ROUTE", "");
      sessionStorage.setItem("CALENDAR", "");
      sessionStorage.setItem("HAS_NOTIFICATION", "");
      sessionStorage.setItem("ORGANIZATION_DATA", "");
      sessionStorage.setItem("FULL_METHOD_SELECTED", "");
      sessionStorage.setItem("FILTERED_TICKET_EVENTS", "");
      sessionStorage.setItem("STRUCTURE_ID", "");
      sessionStorage.setItem("CARDS_PARENT", "");
      sessionStorage.setItem("CREDIT_CARDS", "");
      sessionStorage.setItem("NEWS", "");
      sessionStorage.setItem("LAST_GET_USER_DATA", "");
      sessionStorage.setItem("METHOD_SELECTED", "");
      sessionStorage.setItem("FILTERED_TICKET_EVENTS", "");
      sessionStorage.setItem("QR_FROM", "");
      sessionStorage.setItem("WALLET", "");
      sessionStorage.setItem("CLOSE_EVENTS", "");
      sessionStorage.setItem("structureId", "");
      sessionStorage.setItem("deliversToTable", "");
      sessionStorage.setItem("MAIN_CARTAO", "");
      sessionStorage.setItem("SHOW_FILTERED_EVENTS", "");
      sessionStorage.setItem("USER_DEPENDENTS", "");
      sessionStorage.setItem("CURRENT_ORDERS", "");
      sessionStorage.setItem("LAST_DAY_ESCOLHER_UNIDADE", "");
      sessionStorage.setItem("deliverToBalcony", "");
      sessionStorage.setItem("STRUCTURES_QR", "");
      sessionStorage.setItem("LAST_GET_HOME", "");
      sessionStorage.setItem("BOLETOS", "");
      $(".sidenav").sidenav("close");
      this.$router.push("/LogIn");
    } catch (e) {
      console.log(e);
    }
  }

  openAndCloseCollapse() {
    $(".collapsible-header").toggleClass("opened");
  }

  logOff() {
    Util.logOff();
  }
}
